// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

let mapControllerPromise

function registerMapControllerWhenNeeded() {
  if (!document.querySelector("[data-controller~='map']")) return

  mapControllerPromise ||= import("./map_controller").then(({ default: MapController }) => {
    application.register("map", MapController)
  })
}

document.addEventListener("turbo:load", registerMapControllerWhenNeeded)
registerMapControllerWhenNeeded()
